import React from 'react';
import c from '../w.js';

const IconInr = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M16.4744 9.1052H14.6591C14.5696 8.5427 14.3714 8.03773 14.071 7.60307L16.0206 7.60946L16.4872 5.90918H8.03691L7.53833 7.88432H9.94174C11.1754 7.88432 11.8977 8.34455 12.1917 9.1052H7.99856L7.53833 10.7799H12.2557C11.9872 11.662 11.201 12.199 9.94174 12.199H7.73009L7.73648 13.618L12.2109 19.0001H14.8764V18.885L10.8366 13.9312L10.9133 13.9056C13.24 13.5988 14.3778 12.4546 14.6527 10.7799H16.0206L16.4744 9.1052Z" })
  )
);

export { IconInr };
